var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('header-area',{attrs:{"to":{ name: 'zube-index' },"title":"spendenbescheinigung.digital","top-menu-items":[],"user-dropdown-items":[],"orgcrumbs":[],"id":"head-area"}}),_c('div',[_vm._v("spendenbescheinigung.digital funktioniert")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }